import { DEFAULT_PARTNER_MARGIN } from '@/constants/locales/calculator';
import type { ScenarioInputs, ScenarioType } from '@/types/scenario';
import { create } from 'zustand';

export const defaultInputs: ScenarioInputs = {
  vendorIdList: [],
  customerId: '',
  vendorId: '',
  invoicingConcept: undefined,

  invoicingCurrency: 'USD',
  sellThroughLocalPartner: true,
  partnerMargin: DEFAULT_PARTNER_MARGIN,

  invoicingAmount: undefined,
  localCurrency: 'USD',
  selectedScenarios: ['localPartner', 'internationalInvoicing', 'localSubsidiary', 'alsoThere'],
};

type ScenarioState = {
  inputs: ScenarioInputs;

  // UI state (modal)
  onboardingOpen: boolean;

  // Visibility state for scenarios
  visibleScenarios: Set<ScenarioType>;

  // actions
  setOnboardingOpen: (v: boolean) => void;
  setInputs: (patch: Partial<ScenarioInputs>) => void;
  setField: <K extends keyof ScenarioInputs>(key: K, value: ScenarioInputs[K]) => void;
  resetInputs: () => void;
  setVisibleScenarios: (scenarios: Set<ScenarioType>) => void;
  toggleScenario: (type: ScenarioType) => void;
};

export const useScenarioStore = create<ScenarioState>(set => ({
  inputs: defaultInputs,
  onboardingOpen: false,
  visibleScenarios: new Set<ScenarioType>(['localPartner', 'internationalInvoicing', 'localSubsidiary', 'alsoThere']),

  setOnboardingOpen: v => set({ onboardingOpen: v }),

  setInputs: patch =>
    set(state => ({
      inputs: { ...state.inputs, ...patch },
    })),

  setField: (key, value) =>
    set(state => ({
      inputs: { ...state.inputs, [key]: value },
    })),

  resetInputs: () => set({ inputs: defaultInputs }),

  setVisibleScenarios: scenarios => set({ visibleScenarios: scenarios }),

  toggleScenario: type =>
    set(state => {
      const newSet = new Set(state.visibleScenarios);
      if (newSet.has(type)) {
        // No permitir ocultar si es el último visible
        if (newSet.size > 1) {
          newSet.delete(type);
        }
      } else {
        newSet.add(type);
      }
      return { visibleScenarios: newSet };
    }),
}));
